import { Outlet } from "react-router";
import { Header } from "../components/Header/"
import classes from "./index.module.scss";
import Footer from "../components/Footer";
import { TopLoadingBar } from "../components/TopLoadingBar";
import { useNavigation } from "react-router";

export const DefaultLayout = () => {
  const navigation = useNavigation();
  const loading = navigation.state !== "idle";

  return (
    <div className={classes.defaultLayoutContainer}>
      <TopLoadingBar loading={loading} />
      <Header />
      {/* {isDesktop && (
        <div className={classes.sidenav}>
          <Sidenav links={links} />
        </div>
      )} */}
      <main>
        <div className={classes.pageContent}>
          <Outlet />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default DefaultLayout;
